import {getReportParams, report} from '../../../../middleware/report';
import {DwhActionType, TransferAccountStep, transferOption} from '../Constant/Constant';

export function dwhFirstOnloadReport({selectedHetPay, userDetails}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'NewOrder';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Setting order Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'New Line Page Displayed';
  reportParams.param1 = selectedHetPay;
  reportParams.idNumber = userDetails.IDNumber;
  reportParams.customerName = `${userDetails?.firstName} ${userDetails?.lastName}`;
  reportParams.subscriber = userDetails?.contactNumber;
  report(reportParams);
}

export function dwhStepOneContinueButtonReport({selectedHetPay, simNumber, param3, param7, userDetails}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'NewOrder';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Setting order Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'New Line Button Clicked';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = simNumber;
  reportParams.param3 = param3;
  reportParams.param7 = param7;
  reportParams.idNumber = userDetails.IDNumber;
  reportParams.customerName = `${userDetails?.firstName} ${userDetails?.lastName}`;
  reportParams.subscriber = userDetails?.contactNumber;
  report(reportParams);
}

//--report odelia

export function dwhGeneralReport({data, actionType, messageText, status}) {
  const param2ActionType = [
    DwhActionType.ChoosePackagePageRegularSIM,
    DwhActionType.SuccessScreenRegularSIM,
    DwhActionType.SuccessScreenESIM,
  ];
  const param4ActionType = [
    DwhActionType.ChoosePackagePageRegularSIM,
    DwhActionType.SuccessScreenRegularSIM,
    DwhActionType.SuccessScreenESIM,
    DwhActionType.ErrorScreen,
    DwhActionType.ChoosePackagePageESIM,
    DwhActionType.ESIMInstructionsPage,
  ];
  const param5ActionType = [DwhActionType.SuccessScreenESIM, DwhActionType.ESIMInstructionsPage];
  const param6ActionType = [
    DwhActionType.DeliveryDetailsPageRegularSIM,
    DwhActionType.ChooseDeliveryTime,
    DwhActionType.SuccessScreenRegularSIM,
  ];

  let actionSuccess = [DwhActionType.SuccessScreenRegularSIM, DwhActionType.SuccessScreenESIM];
  let reportParams = getReportParams();
  let transferType = data.selectedTransferOption === transferOption.newLine ? 'NewLine' : 'TransferAccount';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'NewOrder';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = actionSuccess.includes(actionType)  ?  transferType + "-" + actionType  : actionType;
  reportParams.status = status;
  reportParams.messageText = messageText;
  reportParams.param1 = data.selectedHetPay;
  reportParams.param2 = param2ActionType.includes(actionType) ? data.simCardNumber : '';
  reportParams.param3 = getParam3(data);
  reportParams.param4 = param4ActionType.includes(actionType) ? data.selectedPricePlan?.plan_code : '';
  reportParams.param5 = param5ActionType.includes(actionType) ? data.email : '';
  reportParams.param6 = param6ActionType.includes(actionType) ? data.simCardCount.count.count : '';
  reportParams.param7 = data.selectedPhoneNumber;
  reportParams.idNumber = data.userDetails?.IDNumber;
  reportParams.banId = data.selectedBanNumber;
  reportParams.customerName = `${data.userDetails?.firstName} ${data.userDetails?.lastName}`;
  reportParams.subscriber = data.userDetails?.contactNumber;
  reportParams.businessDetails= actionSuccess.includes(actionType) ? {_subscriber : data.selectedPhoneNumber} : null;
  report(reportParams);
}

function getParam3(data) {
  let param = '';
  if (data.hasSimCard === true && data.transferOption === transferOption.niud) {
    param = 'סים קיים ניוד';
  } else if (data.hasSimCard === true && data.selectedTransferOption === transferOption.newLine) {
    param = 'סים קיים קו חדש';
  } else if (data.hasSimCard === false && data.selectedTransferOption === transferOption.newLine) {
    param = 'eSIM קו חדש';
  } else if (data.hasSimCard === false && data.selectedTransferOption === transferOption.niud) {
    param = 'eSIM ניוד';
  } else if (data.hasSimCard === false && data.selectedTransferOption === transferOption.undefined) {
    param = 'הזמנת סים בלבד';
  }
  return param;
}
